import React from "react";
import "@/App.css";
import { BrowserRouter, Routes, Route } from "react-router-dom";

import { AuthProvider } from "@/context/AuthContext";
import { DialogProvider, BrandToaster } from "@/lib/ui";
import Layout from "@/components/Layout";
import { ProtectedRoute } from "@/components/ProtectedRoute";

import Landing from "@/pages/Landing";
import Login from "@/pages/Login";
import Register from "@/pages/Register";
import ProfileWizard from "@/pages/ProfileWizard";
import MatchFeed from "@/pages/MatchFeed";
import ProfileDetail from "@/pages/ProfileDetail";
import Interests from "@/pages/Interests";
import Chat from "@/pages/Chat";
import Pricing from "@/pages/Pricing";
import PaymentSuccess from "@/pages/PaymentSuccess";
import MyAccount from "@/pages/MyAccount";
import Admin from "@/pages/Admin";
import AdminSettings from "@/pages/AdminSettings";
import ForgotPassword from "@/pages/ForgotPassword";
import ResetPassword from "@/pages/ResetPassword";
import Activate from "@/pages/Activate";
import FamilyCircle from "@/pages/FamilyCircle";
import WaliView from "@/pages/WaliView";
import DnsSetup from "@/pages/DnsSetup";
import Verification from "@/pages/Verification";
import Notifications from "@/pages/Notifications";
import PhotoRequests from "@/pages/PhotoRequests";

export default function App() {
  return (
    <AuthProvider>
      <DialogProvider>
        <BrowserRouter>
          <Layout>
            <Routes>
              <Route path="/" element={<Landing />} />
              <Route path="/login" element={<Login />} />
              <Route path="/register" element={<Register />} />
              <Route path="/forgot-password" element={<ForgotPassword />} />
              <Route path="/reset-password" element={<ResetPassword />} />
              <Route path="/activate" element={<Activate />} />

              <Route path="/profile" element={<ProtectedRoute><ProfileWizard /></ProtectedRoute>} />
              <Route path="/profile/pending" element={<ProtectedRoute><ProfileWizard /></ProtectedRoute>} />

              <Route path="/matches" element={<ProtectedRoute><MatchFeed /></ProtectedRoute>} />
              <Route path="/matches/:id" element={<ProtectedRoute><ProfileDetail /></ProtectedRoute>} />

              <Route path="/interests" element={<ProtectedRoute><Interests /></ProtectedRoute>} />
              <Route path="/chat" element={<ProtectedRoute><Chat /></ProtectedRoute>} />

              <Route path="/pricing" element={<Pricing />} />
              <Route path="/payment/success" element={<ProtectedRoute><PaymentSuccess /></ProtectedRoute>} />

              <Route path="/account" element={<ProtectedRoute><MyAccount /></ProtectedRoute>} />
              <Route path="/family" element={<ProtectedRoute><FamilyCircle /></ProtectedRoute>} />
              <Route path="/verify" element={<ProtectedRoute><Verification /></ProtectedRoute>} />
              <Route path="/notifications" element={<ProtectedRoute><Notifications /></ProtectedRoute>} />
              <Route path="/photo-requests" element={<ProtectedRoute><PhotoRequests /></ProtectedRoute>} />
              <Route path="/wali" element={<WaliView />} />

              <Route path="/admin" element={<ProtectedRoute adminOnly><Admin /></ProtectedRoute>} />
              <Route path="/admin/settings" element={<ProtectedRoute adminOnly><AdminSettings /></ProtectedRoute>} />
              <Route path="/admin/dns" element={<ProtectedRoute adminOnly><DnsSetup /></ProtectedRoute>} />
            </Routes>
          </Layout>
        </BrowserRouter>
        <BrandToaster />
      </DialogProvider>
    </AuthProvider>
  );
}
